import { render, staticRenderFns } from "./pay_config_edit.vue?vue&type=template&id=e90a2862&scoped=true"
import script from "./pay_config_edit.vue?vue&type=script&lang=js"
export * from "./pay_config_edit.vue?vue&type=script&lang=js"
import style0 from "./pay_config_edit.vue?vue&type=style&index=0&id=e90a2862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90a2862",
  null
  
)

export default component.exports